<div class="header-container" [class.web]="(isHandset$ | async) === false">
  <div class="header-content">
    @if (isHandset$ | async) {
      <button class="menu-button" (click)="sidenav.toggle()">
        <app-icon [phosphorClass]="'ph-list'"></app-icon>
      </button>
    }
    <div [ngClass]="(isHandset$ | async) ? 'logo-container-mobile' : 'logo-container'">
      <img src="https://static.soregies.fr/logos/Groupe+Sore%CC%81gies/Logos+Groupe+Soregies/Logo+Groupe+Soregies/Logo+Groupe+Soregies.png" alt="Sorégies" />
    </div>
    @if (environment !== 'Production') {
      <div>
        <span class="environment-header-{{ environment }}">{{ environment }}</span>
      </div>
    }
    <div class="us-container">
      <div class="identity-block profile">
        <app-icon id="user-info-icon" [phosphorClass]="'ph-user ph-fill'" [size]="Size['medium-small']"></app-icon>
        <span>{{ userConnected?.email }}</span>
      </div>
    </div>
  </div>
</div>
